import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4458aa4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-center footer_top\" data-v-4458aa4a><div class=\"flex-col align-start\" data-v-4458aa4a><span data-v-4458aa4a>全国统一服务热线</span><span class=\"mt10\" data-v-4458aa4a>服务时间：8:00-21:00</span></div><div class=\"sep-line-v\" data-v-4458aa4a></div><div data-v-4458aa4a><a href=\"tel:400-900-6896\" style=\"font-size:40px;color:#535353;font-family:Microsoft YaHei;\" data-v-4458aa4a>400-900-6896</a></div></div>", 1)
const _hoisted_3 = {
  class: "flex-center footer_bottom",
  style: {"gap":"20px"}
}
const _hoisted_4 = { class: "footer_about" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "版权所有：北京中盛佳源教育科技有限公司", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer_link" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "http://beian.miit.gov.cn" }, "京ICP备15052609号-2")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://img.alicdn.com/tfs/TB13DzOjXP7gK0jSZFjXXc5aXXa-212-48.png",
    style: {"width":"70px","margin-right":"10px"}
  }),
  /*#__PURE__*/_createTextVNode(" 提供计算与安全服务 ")
], -1))

import {reactive} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const data: any = reactive({
	aboutItem: [
		{
			'name': '加入我们',
			'link': '/666',
		},
		{
			'name': '关于我们',
			'link': '/777',
		},
		{
			'name': '联系我们',
			'link': '/888',
		},
	],
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.aboutItem, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item,
            to: item.link
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7
    ])
  ]))
}
}

})